export default __webpack_public_path__ + "static/media/logo_my_court.a35d9006.png";